import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ForgotPasswordFacade } from '@store/forgot-password/forgot-password.facade';

/**
 * @description Component to display a trace id
 * @WhereIsItUsed
 * - signin-new-password
 * - signin-reset
 * - dot-okta-container
 */
@Component({
  selector: 'dot-forgot-password-trace-section',
  template: `
    <span
      *ngIf="forgotPwdFacade.mostRecentTraceId | async; let traceId"
      class="legal slate-gray tr"
    >
      {{ traceId }}
    </span>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: flex-end;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class TraceSectionComponent {
  constructor(public forgotPwdFacade: ForgotPasswordFacade) {}
}
